// @flow

import * as React from 'react';
import Logging from '@ta/common.logging';
import { LoadingSpinner } from '@ta/styleguide.loading';
import { ProfileCardResponsive } from '@ta/social.cards';
import { LoadingErrorMessage } from '@ta/loading.error';

import styles from './FollowerFolloweeFeed.less';

type Props = {|
  followerFollowees: any,
  loading: boolean,
  error: any,
  refetch: any,
  contentRef: React.ElementRef<*>,
  userId: string,
|};

const FollowerFolloweeFeed = (props: Props) => {
  if (props.error) {
    Logging.error(`Error fetching FollowerFolloweeFeed data for ${props.userId}: `, props.error);

    return <LoadingErrorMessage refetch={props.refetch} />;
  }

  return (
    <div className={styles.feed} ref={props.contentRef}>
      {props.followerFollowees.map(profile =>
        profile ? <ProfileCardResponsive key={profile.userId} profile={profile} /> : null,
      )}
      {props.loading && (
        <div className="ui_card section">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default FollowerFolloweeFeed;
